// Store Zustand per lo stato connessione WebSocket e ultimi eventi
import { create } from 'zustand'
// Coords locale per il realtime (lat/lng) — il tipo @fieldcore/types usa latitude/longitude


export type ConnectionStatus = 'disconnected' | 'connecting' | 'connected' | 'error'

export interface TechnicianCoords {
  lat: number
  lng: number
}

export interface TechnicianPosition {
  userId: string
  name: string
  coords: TechnicianCoords
  updatedAt: string
  isCheckedIn: boolean
}

export interface RealtimeEvent {
  id: string
  type: string
  payload: unknown
  timestamp: string
}

interface RealtimeState {
  connectionStatus: ConnectionStatus
  technicianPositions: Record<string, TechnicianPosition>
  recentEvents: RealtimeEvent[]
}

interface RealtimeActions {
  setConnectionStatus: (status: ConnectionStatus) => void
  updateTechnicianPosition: (position: TechnicianPosition) => void
  addEvent: (event: RealtimeEvent) => void
  clearEvents: () => void
  setTechnicianCheckedOut: (userId: string) => void
}

export const useRealtimeStore = create<RealtimeState & RealtimeActions>()(
  (set) => ({
    connectionStatus: 'disconnected',
    technicianPositions: {},
    recentEvents: [],

    setConnectionStatus: (status) => set({ connectionStatus: status }),

    updateTechnicianPosition: (position) =>
      set((state) => ({
        technicianPositions: {
          ...state.technicianPositions,
          [position.userId]: position,
        },
      })),

    addEvent: (event) =>
      set((state) => ({
        recentEvents: [event, ...state.recentEvents].slice(0, 50),
      })),

    clearEvents: () => set({ recentEvents: [] }),

    setTechnicianCheckedOut: (userId) =>
      set((state) => ({
        technicianPositions: {
          ...state.technicianPositions,
          [userId]: state.technicianPositions[userId]
            ? { ...state.technicianPositions[userId]!, isCheckedIn: false }
            : state.technicianPositions[userId]!,
        },
      })),
  })
)
